module.exports = __webpack_public_path__ + "img/out_wall.7511038f.png";